module.exports = __webpack_public_path__ + "img/pretzel.7be90f65.png";